import React from "react";
import './CoinStyle.css'

const Coin = ()=>{
    return <div id="euro">
    <article class="back"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>  
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>
      <article class="middle"></article>   
    <article class="front"></article>
  </div>
}

export default Coin;